<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6">
                <el-text-field
                  label="Užsakovas"
                  tooltip="Ireg. Pagrindinis. Paieška. Išrašų užsakymai. Užsakovas"
                  v-model="mainData['user_fullname-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.dataVolumeOrderSav"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Duomenų apimtis"
                  tooltip="Ireg. Pagrindinis. Paieška. Išrašų užsakymai. Duomenų apimtis"
                  v-model="mainData['type-search-like']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.searchOrderStatus"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Būsena"
                  tooltip="Ireg. Pagrindinis. Paieška. Išrašų užsakymai. Būsena"
                  v-model="mainData['status-search-custom']"
                />
              </v-col>
              <v-col cols="12" md="6" lg="3">
                <el-autocomplete
                  :items="enumsClassifiers.withdrawalOrderSav"
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Atsiėmimo būdas"
                  tooltip="Ireg. Pagrindinis. Paieška. Išrašų užsakymai. Atsiėmimo būdas"
                  v-model="mainData['withdrawal_method-search-like']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :beforeDates="mainData['created_at-search-to']"
                  label="Gavimo data nuo"
                  tooltip="Ireg. Pagrindinis. Paieška. Išrašų užsakymai. Gavimo data nuo"
                  v-model="mainData['created_at-search-from']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :afterDates="mainData['created_at-search-from']"
                  label="Gavimo data iki"
                  tooltip="Ireg. Pagrindinis. Paieška. Išrašų užsakymai. Gavimo data iki"
                  v-model="mainData['created_at-search-to']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn object="statement-orders" :loading="loading" :reportData="reportData" :listURL="'list/self-service'"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'

export default {
  name: 'AdminSearchOrdersSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.searchData(true)
        } 
      })
    },
  },
}
</script>
